import React from 'react';

import { Check, Alert } from 'jbc-front/components/icons';
import { formatDate, formatDateWithHour } from 'src/utils/Date';
import { getInputTypeName } from 'src/utils/Enum';
import MemoList from 'src/features/Memos';
import { isInTargetDateRange } from 'src/utils/Utils';
import styles from './EmployeePayTableRow.scss';
import { useTranslation,withTranslation } from 'react-i18next';

const JoinedOnStyle = () => {
  const { t } = useTranslation();
  return (
    <span className={styles.icon}>
      <Alert size={16} />
      <span className={styles.baloon}>{t('features.EmployeePays.components.EmployeePayTableRow.Employee_who_entered_the_company_during_the_subjected_period_for_salary_calculation')}</span>
    </span>
  );
};

const ResignedOnStyle = () => {
  const { t } = useTranslation();
  return (
    <span className={styles.icon}>
      <Alert size={16} />
      <span className={styles.baloon}>{t('features.EmployeePays.components.EmployeePayTableRow.Employee_who_retired_during_the_subjected_period_for_salary_calculation')}</span>
    </span>
  );
};

class EmployeePayTableRow extends React.Component {
  state = {
    clickThisRow: false
  };

  onClickHandler = () => {
    if (!this.state.clickThisRow) {
      this.state.clickThisRow = true;
      this.props.onClick();
    }
  };

  render() {
    const {
      employeeId,
      staffCode,
      fullName,
      isSyncAttendance,
      inputType,
      lastEditAt,
      employeeJoinedOn,
      employeeResignedOn,
      paymentRange,
      attendanceStartDate,
      attendanceEndDate,
    } = this.props;

    const { targetStartDate, targetEndDate } = paymentRange || {};
    const hasResignedStyle =
      isInTargetDateRange(targetStartDate, targetEndDate, employeeResignedOn) ||
      isInTargetDateRange(attendanceStartDate, attendanceEndDate, employeeResignedOn);
    const hasJoinedStyle = isInTargetDateRange(targetStartDate, targetEndDate, employeeJoinedOn);

    return (
      <tr onClick={() => this.onClickHandler()} className="table-hover">
        <td>
          <MemoList employeeId={employeeId} />
        </td>
        <td>{staffCode}</td>
        <td>
          {fullName}
        </td>
        <td>{isSyncAttendance ? <Check size={16} className={styles.check} /> : ''}</td>
        <td>
          {formatDateWithHour(lastEditAt)}
          {lastEditAt ? <p>（{this.props.t(getInputTypeName(inputType))}）</p> : ''}
        </td>
        <td>
          <span className={hasJoinedStyle ? styles.dateWithIcon : styles.date}>
            {formatDate(employeeJoinedOn)}
            {hasJoinedStyle && <JoinedOnStyle />}
          </span>
        </td>
        <td>
          <span className={hasResignedStyle ? styles.dateWithIcon : styles.date}>
            {formatDate(employeeResignedOn)}
            {hasResignedStyle && <ResignedOnStyle />}
          </span>
        </td>
      </tr>
    );
  }
}

export default withTranslation()(EmployeePayTableRow);
